import React, { useEffect, useRef, useState } from 'react';
import Ratio from 'react-bootstrap/Ratio';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import styles from '../styles/contcatus.module.scss';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import ManagerSlider from './ManagerCards';
import fetchUtil from '../utils/fetchUtil';
import Card from 'react-bootstrap/Card';
import Slider from 'react-slick';
import Link from 'next/link';
import _sortBy from 'lodash/sortBy';
import Select from 'react-select';
import CustomImage from './CustomImage';
import { useRouter } from 'next/router';
import { isFrappeOrJotFormClass } from '../utils/helpers';
import LazyMedia from './LazyMedia';
import OfficeAddress from './ContactUs/OfficeAddress';

const Contactus: React.FC = (props: any) => {
  const router = useRouter();
  const videosSlidersettings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
  };
  const { officeCountriesData, contactusData } = props;
  const sortedOfficeCountriesData = _sortBy(officeCountriesData, 'id');
  const [selectedCountryId, setSelectedCountryId] = useState<number>(sortedOfficeCountriesData[0].id);
  const [filteredOfficeCountriesData, setFilteredOfficeCountriesData] = useState<any>({});
  const [kcOffices, setKcOffices] = useState<any>([]);
  const [kcOfficesFiltered, setKcOfficesFiltered] = useState<any>([]);
  const [kcOfficesCities, setKcOfficesCities] = useState<any>([]);
  const [selectedCity, setSelectedCity] = useState<string>('');
  const [officesLoader, setOfficesLoader] = useState<boolean>(false);
  const scrollRef = useRef<HTMLDivElement>(null);
  const addressRef = useRef<HTMLDivElement>(null);

  const getOfficesData = (
    id: number,
    city: string,
    citiesCondition?: boolean
  ) => {
    const searchCondition = city ? `&city_contains=${city}` : '';
    const officesUrl = `${process.env.NEXT_PUBLIC_API_BASE_URL}/offices?office_country=${id}&_start=0&_sort=city:ASC${searchCondition}`;
    setOfficesLoader(true);
    fetchUtil(officesUrl, 'GET', {}, '', false)
      .then((res: any) => {
        if (res?.length > 0) {
          setKcOffices(res);
          setKcOfficesFiltered(res);
          const citiesList = res.map((officeData: any) => {
            return { label: `${officeData.city}${officeData.area ? ' '+officeData.area : ''}`, value: `${officeData.city}${officeData.area ? ' '+officeData.area : ''}`};
          });
          citiesCondition && setKcOfficesCities(citiesList);
        } else {
          setKcOffices([]);
        }
      })
      .catch((err: any) => {
        if(process.env.NEXT_PUBLIC_ENV === 'development') {
          console.log(err)
        }
      })
      .finally(() => setOfficesLoader(false));
  };

  useEffect(() => {
    getOfficesData(1, selectedCity, true);
  }, []);

  const officeCard = (office: any) => {
    const { city, name, mobile , area} = office;
    return (
      <Card.Body id='office-card' className={styles.contcatMainCard}>
        <h4>{city} {area}</h4>
        <div className={styles.contactCard}>
          <div>
            <svg
              className={styles.icon}
              width='18'
              height='18'
              viewBox='0 0 18 18'
              fill='226CF5'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M3.67857 17V17.75H5.17857V17H3.67857ZM12.8214 17V17.75H14.3214V17H12.8214ZM5.17857 17V14.7137H3.67857V17H5.17857ZM7.85714 12.0357H10.1429V10.5357H7.85714V12.0357ZM12.8214 14.7137V17H14.3214V14.7137H12.8214ZM10.1429 12.0357C11.6224 12.0357 12.8214 13.2345 12.8214 14.7137H14.3214C14.3214 12.4057 12.4504 10.5357 10.1429 10.5357V12.0357ZM5.17857 14.7137C5.17857 13.2345 6.37764 12.0357 7.85714 12.0357V10.5357C5.54955 10.5357 3.67857 12.4057 3.67857 14.7137H5.17857ZM9 3.67857C7.32342 3.67857 5.96429 5.03771 5.96429 6.71429H7.46429C7.46429 5.86613 8.15185 5.17857 9 5.17857V3.67857ZM12.0357 6.71429C12.0357 5.03771 10.6766 3.67857 9 3.67857V5.17857C9.84815 5.17857 10.5357 5.86613 10.5357 6.71429H12.0357ZM9 9.75C10.6766 9.75 12.0357 8.39086 12.0357 6.71429H10.5357C10.5357 7.56244 9.84815 8.25 9 8.25V9.75ZM9 8.25C8.15185 8.25 7.46429 7.56244 7.46429 6.71429H5.96429C5.96429 8.39086 7.32342 9.75 9 9.75V8.25ZM2.14286 1.75H15.8571V0.25H2.14286V1.75ZM16.25 2.14286V15.8571H17.75V2.14286H16.25ZM15.8571 16.25H2.14286V17.75H15.8571V16.25ZM1.75 15.8571V2.14286H0.25V15.8571H1.75ZM2.14286 16.25C1.92589 16.25 1.75 16.0741 1.75 15.8571H0.25C0.25 16.9025 1.09746 17.75 2.14286 17.75V16.25ZM16.25 15.8571C16.25 16.0741 16.0741 16.25 15.8571 16.25V17.75C16.9025 17.75 17.75 16.9025 17.75 15.8571H16.25ZM15.8571 1.75C16.0741 1.75 16.25 1.92589 16.25 2.14286H17.75C17.75 1.09746 16.9025 0.25 15.8571 0.25V1.75ZM2.14286 0.25C1.09746 0.25 0.25 1.09746 0.25 2.14286H1.75C1.75 1.92589 1.92589 1.75 2.14286 1.75V0.25Z'
                fill='#226CF5'
              />
            </svg>
          </div>
          <div>
            <p>{name}</p>
          </div>
        </div>
        <div className={styles.contactCard} style={{ marginBottom: '0px' }}>
          <div>
            <svg
              className={styles.icon}
              width='18'
              height='18'
              viewBox='0 0 18 18'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M5.82197 1H3.28571C2.02335 1 1 2.02335 1 3.28571V5.57143C1 11.8833 6.11675 17 12.4286 17H14.7143C15.9767 17 17 15.9767 17 14.7143V13.1349C17 12.702 16.7554 12.3063 16.3682 12.1127L13.6072 10.7322C12.9851 10.4211 12.2318 10.7332 12.0119 11.393L11.6716 12.4139C11.4511 13.0752 10.7728 13.4688 10.0892 13.3321C7.35347 12.785 5.21502 10.6465 4.66787 7.91076C4.53116 7.22723 4.92483 6.54887 5.58612 6.32843L6.85313 5.9061C7.41967 5.71725 7.7453 5.12406 7.60046 4.54471L6.9307 1.86567C6.80351 1.35691 6.34639 1 5.82197 1Z'
                stroke='#226CF5'
                strokeWidth='1.5'
              />
            </svg>
          </div>
          <div>
            <p>{mobile}</p>
          </div>
        </div>
        <div className={styles.arrowClass}>
          <svg
            viewBox='0 0 1024 1024'
            version='1.1'
            xmlns='http://www.w3.org/2000/svg'
            height={40}
            width={40}
          >
            <path d='M640 768c-12.8 0-21.333333-4.266667-29.866667-12.8-17.066667-17.066667-17.066667-42.666667 0-59.733333l213.333333-213.333333c17.066667-17.066667 42.666667-17.066667 59.733333 0s17.066667 42.666667 0 59.733333l-213.333333 213.333333C661.333333 763.733333 652.8 768 640 768z' />
            <path d='M853.333333 554.666667c-12.8 0-21.333333-4.266667-29.866667-12.8l-213.333333-213.333333c-17.066667-17.066667-17.066667-42.666667 0-59.733333s42.666667-17.066667 59.733333 0l213.333333 213.333333c17.066667 17.066667 17.066667 42.666667 0 59.733333C874.666667 550.4 866.133333 554.666667 853.333333 554.666667z' />
            <path d='M853.333333 554.666667 170.666667 554.666667c-25.6 0-42.666667-17.066667-42.666667-42.666667s17.066667-42.666667 42.666667-42.666667l682.666667 0c25.6 0 42.666667 17.066667 42.666667 42.666667S878.933333 554.666667 853.333333 554.666667z' />
          </svg>
        </div>
      </Card.Body>
    );
  };

  const getCountryName = () =>
    sortedOfficeCountriesData.length > 0 &&
    sortedOfficeCountriesData.filter(
      (country: any) => country.id === selectedCountryId
    )[0].countryName;

  useEffect(() => {
    if (selectedCity) {
      const filteredOffices =
        kcOffices?.length > 0 &&
        kcOffices.filter((office: any) => (office.city === selectedCity) || (office.city + ' ' + office.area === selectedCity));
      setKcOfficesFiltered(filteredOffices);
    } else setKcOfficesFiltered(kcOffices);
  }, [selectedCity]);

  useEffect(() => {
    setFilteredOfficeCountriesData(sortedOfficeCountriesData.filter(
      (country: any) => country.id === selectedCountryId
    )[0])
  }, [selectedCountryId]);

  return (
    <>
    <link rel="preload" 
      as="image" 
      href="/images/contcatus/contcat-us-start-img.svg" 
      fetchPriority="high">

      </link>
      <div id='contcatus-section' className={styles.contcatus_section}>
        <Container>
          <div className={styles.breadcrum}>
            <Row className='text-center'>
              <Col lg={8} md={8} xs={12} className={styles.centered}>
                <Breadcrumb>
                  <Breadcrumb.Item href='/' style={{ opacity: 0.5 }}>
                    Home
                  </Breadcrumb.Item>
                  <Breadcrumb.Item href=''> Contact Us </Breadcrumb.Item>
                </Breadcrumb>
                <div className={styles.heading}>
                  <h1>{contactusData?.title}</h1>
                  <p>{contactusData?.subTitle}</p>
                  <div className={styles.buttongp}>
                    <a
                      className={`${styles.enquirebtn
                        } ${isFrappeOrJotFormClass(contactusData?.meta?.jotforms[0]?.jotformid)}`}
                        onClick={()=> { !contactusData?.meta?.jotforms[0]?.jotformId && router.push(contactusData?.externalLink) }}
                    >
                     { contactusData?.bannerBtn?.label || 'Enquire Now' }
                    </a>
                    <a
                      className={styles.kcbtn}
                      onClick={() => addressRef?.current?.scrollIntoView()}
                    >
                     KC Overseas Head Office
                    </a>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
      <div id='our-offices' className={styles.our_offices}>
        <Container>
          <Row>
            <Col lg={8} className={styles.centered}>
              <div className={styles.offices}>
                <Row className='text-center'>
                  <Col xl={12} md={12} xs={12}>
                    <h2>Our Offices</h2>
                  </Col>
                </Row>
              </div>
              <div className={styles.country_offices} ref={scrollRef}>
                <Row>
                  {sortedOfficeCountriesData?.length > 0 &&
                    sortedOfficeCountriesData.map((office: any) => {
                      const {
                        countryName,
                        flag: { url, alternativeText, formats },
                        id,
                      } = office;
                      return (
                        <Col md={4} lg={4} xs={6} sm={6} key={id}>
                          <div
                            className={`${styles.country_flags} ${selectedCountryId === id
                              ? styles.activeCountry
                              : ''
                              }`}
                            onClick={() => {
                              setSelectedCity('');
                              setKcOffices([]);
                              setKcOfficesFiltered([]);
                              setSelectedCountryId(id);
                              getOfficesData(id, '', true);
                              scrollRef?.current?.scrollIntoView({block: "start"});
                            }}
                          >
                            <div className={styles.flagImgContent}>
                              <CustomImage
                                src={`${url}`}
                                alt={`${alternativeText}`}
                                width={45}
                                height={25}
                              />
                              <span>{countryName}</span>
                            </div>
                          </div>
                        </Col>
                      );
                    })}
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      {kcOfficesFiltered?.length > 0 && (
        <div id='all-offices' className={styles.all_offices}>
          <Container>
            <Row>
              <Col xl={9} md={8} xs={12}>
                <h2>{filteredOfficeCountriesData?.sectionTitle ?? "Offices in " + getCountryName()}</h2>
              </Col>
              <Col xl={3} md={4} xs={12}>
                <Select
                  options={kcOfficesCities}
                  placeholder='Select Office'
                  className={styles.selectClass}
                  classNamePrefix='mySelect'
                  isClearable
                  value={
                    selectedCity
                      ? { label: selectedCity, value: selectedCity }
                      : ''
                  }
                  onChange={(selected: any) =>
                    setSelectedCity(selected?.value || '')
                  }
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: 5,
                  })}
                />
              </Col>
            </Row>
            <Row>
              <Container
                id='officesContain'
                className={styles.officesContainer}
              >
                <div>
                  <Row>
                    {officesLoader ? (
                      <div>Loading...</div>
                    ) : kcOfficesFiltered?.length > 0 && (
                      kcOfficesFiltered.map((office: any) => {
                        return (
                          <Col lg={4} md={6} xs={12} key={office.id}>
                            <Link href={`/contact-us/${office?.slug || ''}`}>
                              <a>
                                <Card className={styles.card}>
                                  {officeCard(office)}
                                </Card>
                              </a>
                            </Link>
                          </Col>
                        );
                      })
                    )}
                  </Row>
                </div>
              </Container>
            </Row>
          </Container>
        </div>
      )}
      {filteredOfficeCountriesData?.regionalManagers && (
        <div id='reg-manag' className={styles.regionalManagers}>
          <Container>
            <Row className='text-center'>
              <div>
                <h2>{filteredOfficeCountriesData.regionalManagers.title}</h2>
              </div>
            </Row>
            <Row id='regional-managers'>
              {filteredOfficeCountriesData.regionalManagers.managerCard?.length > 0 && (
                <ManagerSlider
                  data={filteredOfficeCountriesData.regionalManagers.managerCard}
                />
              )}
            </Row>
          </Container>
        </div>
      )}
      {filteredOfficeCountriesData?.countrySalesManagers && (
        <div className={styles.regionalSalesManagers}>
          <Container>
            <Row className="text-center">
              <div>
                <h2>{filteredOfficeCountriesData.countrySalesManagers.title}</h2>
              </div>
            </Row>
            <Row>
              {filteredOfficeCountriesData.countrySalesManagers.managerCard?.length > 0 &&
                <ManagerSlider data={filteredOfficeCountriesData.countrySalesManagers.managerCard} />}
            </Row>
          </Container>
        </div>
      )}
      <div id='regional-manvedio' className={styles.regionalManVedio}>
        <Container>
          <Row className='text-center'>
            <div className='mb-5'>
              <h2>{contactusData?.rmVideoTitle}</h2>
            </div>
          </Row>
          <Slider {...videosSlidersettings}>
            {contactusData.rmVideos.length > 0 &&
              contactusData.rmVideos.map((video: any) => {
                return (
                  <Row>
                    <Col>
                      <div className={styles.mangerVideo}>
                        <Ratio aspectRatio='16x9'>
                          <LazyMedia type='image/svg+xml' src={video.imageUrl} tag='embed' />
                        </Ratio>
                      </div>
                    </Col>
                  </Row>
                );
              })}
          </Slider>
        </Container>
      </div>
      <div id='office-address' className={styles.officeAddress} ref={addressRef}>
        <OfficeAddress />
      </div>
    </>
  );
};

export default Contactus;